import { render } from "./CourseCenter.vue?vue&type=template&id=9411e822&scoped=true"
import script from "./CourseCenter.vue?vue&type=script&lang=js"
export * from "./CourseCenter.vue?vue&type=script&lang=js"

import "./CourseCenter.vue?vue&type=style&index=0&id=9411e822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9411e822"]])

export default __exports__